import { getProviders, getCsrfToken } from 'next-auth/client'

// Components.
import Layout from 'components/Layout/Layout'
import Login from 'components/Login'

// Data services.
import apiService from 'lib/services/pixels-headless/common'

export default function SignIn({ data, loginProviders, loginCsrfToken }) {
  const pageData = { ...data }

  // Append generic SEO data.
  pageData.seo = {
    title: 'Happens - Kirjaudu / rekisteröidy',
    meta: {
      description: 'Kirjaudu sisään Happens-palveluun',
      'og:description': 'Kirjaudu sisään Happens-palveluun',
      'og:title': 'Happens kirjautuminen',
      'og:image': null,
      'og:site_name': 'Happens',
      'og:locale': 'fi',
    },
    canonical: 'https://happens.fi/auth/kirjaudu',
    alternative: null,
  }

  return (
    <Layout data={pageData}>
      <div className="container">
        <h1 className="h4 gradient-text text-center">
          Rekisteröidy / kirjaudu
        </h1>
        <Login providers={loginProviders} token={loginCsrfToken} />
      </div>
    </Layout>
  )
}

/**
 * Get common page data + login methods.
 */
SignIn.getInitialProps = async (context) => ({
  data: await apiService.getGlobals(),
  loginProviders: await getProviders(),
  loginCsrfToken: await getCsrfToken(context),
})
